import React, { FC } from 'react'
import { View } from 'react-native'

import formatDecimals from '@ambire-common/utils/formatDecimals/formatDecimals'
import { createGlobalTooltipDataSet } from '@common/components/GlobalTooltip'
import { useTranslation } from '@common/config/localization'
import Text from '@common/components/Text'
import useTheme from '@common/hooks/useTheme'
import { HIDDEN_BALANCE_MASK } from '@common/modules/dashboard/helpers/hiddenBalance'
import { NEUTRAL_BACKGROUND_HOVERED } from '@common/modules/dashboard/screens/styles'
import spacings from '@common/styles/spacings'
import { THEME_TYPES } from '@common/styles/themeConfig'
import common from '@common/styles/utils/common'
import flexbox from '@common/styles/utils/flexbox'

export interface RailgunMissingPoiUsdPillProps {
  usdTotal: number
  /** Hide-balance toggle: keep the pill (it signals pending funds) but mask the amount. */
  hidden?: boolean
}

const RailgunMissingPoiUsdPill: FC<RailgunMissingPoiUsdPillProps> = ({ usdTotal, hidden = false }) => {
  const { theme, themeType } = useTheme()
  const { t } = useTranslation()

  if (usdTotal <= 0) return null

  const labelColor =
    themeType === THEME_TYPES.DARK ? theme.primaryBackgroundInverted : theme.primaryBackground

  return (
    <View
      style={[
        flexbox.directionRow,
        flexbox.alignCenter,
        spacings.phTy,
        spacings.pvMi,
        common.borderRadiusPrimary,
        {
          backgroundColor: NEUTRAL_BACKGROUND_HOVERED,
          minHeight: 28
        }
      ]}
      dataSet={createGlobalTooltipDataSet({
        id: 'overview-missing-poi-usd',
        // Sender-side proofs are only submitted while the SENDING wallet is open, so when the
        // user moved funds between their own accounts, opening the sender is what clears this.
        content: t(
          'Waiting for Private Proof of Innocence. If you sent these funds from another of your accounts, open ZKX on that account to finish it.'
        )
      })}
    >
      <Text
        fontSize={12}
        weight="number_medium"
        style={{ lineHeight: 14 }}
        color={labelColor}
        testID="missing-poi-usd-pill"
      >
        {t('Incoming {{amount}}', {
          amount: hidden ? HIDDEN_BALANCE_MASK : formatDecimals(usdTotal, 'value')
        })}
      </Text>
    </View>
  )
}

export default RailgunMissingPoiUsdPill
